/* src/authService.js */
import Auth0 from 'auth0-js';

const auth0 = new Auth0.WebAuth({
  domain: "login.golingoapp.com",               // e.g., your tenant’s domain
  clientID: "qXplijQBTBiXyYsEkx0YP1lLXf0X8b2Z",    // your client ID
  responseType: "token id_token",
  redirectUri: window.location.origin,
  realm: "Username-Password-Authentication"       // your database connection name
});

export default auth0;